import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Global state of the "IOR profile is incomplete" modal (#13536).
 * Opened by ErrorResponseInterceptor when the backend rejects an action
 * with 400 + tag `company_profile_incomplete` (ISF / Entry Summary duplicate);
 * rendered once at the app root.
 */
@Injectable({ providedIn: 'root' })
export class CompanyProfileIncompleteModalService {
  public readonly isOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public open(): void {
    if (!this.isOpen$.value) {
      this.isOpen$.next(true);
    }
  }

  public close(): void {
    if (this.isOpen$.value) {
      this.isOpen$.next(false);
    }
  }
}
